import React, { type FunctionComponent, useState } from 'react'
import { authenticatedFetchData, API_HOST } from '../../../lib'
import { logError } from '@tomra/datadog-browser-logging'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  refetchNotes: () => void
  setEditMode: (edit: boolean) => void
  noteId: string
  note: string
}

export const NoteEdit: FunctionComponent<Props> = ({ refetchNotes, setEditMode, noteId, note }) => {
  const [editNote, setEditNote] = useState(note)
  const [notesStatus, setNotesStatus] = useState('')
  const [editStatus, setEditStatus] = useState('')

  const noteEdit = (e: any) => {
    e.preventDefault()
    setEditStatus('loading')

    authenticatedFetchData(`${API_HOST}/mytomra/v1.0/hotlinetool/managernotes/${noteId}`, {
      method: 'PUT',
      body: JSON.stringify({
        note: editNote
      })
    })
      .run()
      .then(
        () => {
          setNotesStatus('')
          setEditStatus('')
          setEditNote('')
          setEditMode(false)
          refetchNotes()
        },
        (error: Error) => {
          setNotesStatus('failed')
          logError(new Error('Failed to edit note'), error)
        }
      )
  }

  if (notesStatus === 'failed') {
    return (
      <div className="rounded-lg border-l-[3px] border-rose-500 bg-white p-4 text-left shadow-md dark:bg-gray-900 mt-4 mb-4">
        Whoopsie! Failed to update note. Please try again.
      </div>
    )
  }

  return (
    <>
      <label htmlFor="editNote" className="block mb-2">
        Edit note
      </label>

      <textarea
        id="editNote"
        className="textarea min-w-full resize-none"
        onChange={evt => setEditNote(evt.target.value)}
        value={editNote}
      />

      <div className="mt-4 flex justify-end">
        <Button className="mr-2" onClick={() => setEditMode(false)}>
          Cancel
        </Button>

        <Button variant="primary" className="ml-2" onClick={noteEdit} disabled={editNote === ''}>
          {editStatus === 'loading' ? <div className="loadingSpinner" aria-label="Please wait" /> : 'Save'}
        </Button>
      </div>
    </>
  )
}
